// Foco "frio" no boot: aplicado mas sem destaque visual.
// Vira "quente" (com cor da marca) ao primeiro input de navegação.

import { useEffect, useState } from 'react'

export function useFocusActivation(): boolean {
  const [activated, setActivated] = useState(false)

  useEffect(() => {
    if (activated) return
    const onInput = () => setActivated(true)
    window.addEventListener('keydown', onInput, { once: true })
    window.addEventListener('mousemove', onInput, { once: true })
    window.addEventListener('touchstart', onInput, { once: true })
    return () => {
      window.removeEventListener('keydown', onInput)
      window.removeEventListener('mousemove', onInput)
      window.removeEventListener('touchstart', onInput)
    }
  }, [activated])

  return activated
}
